module.exports = __webpack_public_path__ + "img/ascending.efbbaf55.svg";